import { Sport, League } from './registerConstants';

export interface RegisterFormState {
  fullName: string;
  country: string;
  sports: Sport[];
  league: League | null;
  description: string;
  avatarColor1: string;
  avatarColor2: string;
  avatarSeed: number;
  email: string;
  password: string;
  repeatPassword: string;
  birthdate: Date | null;
  skipExpert: boolean;
}

export const buildProfileTags = (form: RegisterFormState): string[] =>
  [...form.sports.map((s) => s.name), form.league?.name].filter(Boolean) as string[];
